import { Routes } from '@angular/router';
import { MsalGuard } from "@azure/msal-angular";
import { RoleGuard } from './core/auth/role.guard';
import { Injectable } from '@angular/core';
import { ForbiddenComponent } from './core/forbidden/forbidden.component';
import { permissions } from './core/auth/permissions';
import { HomeComponent } from './features/home/home.component';
import { AboutComponent } from './features/about/about.component';
//import { AuthCallbackComponent } from './core/auth/auth-callback.component';

const dashboardModule = () => import('./features/dashboard/dashboard.routing').then(x => x.dashboardRoutes);
const auditsModule = () => import('./features/audit/audit.routing').then(x => x.auditRoutes);
const chartsModule = () => import('./features/chart/chart.routing').then(x => x.chartRoutes);
const chemicalsModule = () => import('./features/chemical/chemical.routing').then(x => x.chemicalRoutes);
const companysModule = () => import('./features/company/company.routing').then(x => x.companyRoutes);
const comparationPageModule = () => import('./features/comparison-page/comparison-page.routing').then(x => x.comparisonPageRoutes);
const crewsModule = () => import('./features/crew/crew.routing').then(x => x.crewRoutes);
const customersModule = () => import('./features/customer/customer.routing').then(x => x.customerRoutes);
const logAtpsModule = () => import('./features/logatp/logatp.routing').then(x => x.logAtpRoutes);
const logBqsModule = () => import('./features/logbq/logbq.routing').then(x => x.logAtpRoutes);
const logWasModule = () => import('./features/logwa/logwa.routing').then(x => x.logWaRoutes);
const logAcidsModule = () => import('./features/prejob/prejob.routing').then(x => x.preJobRoutes);
const preJobModule = () => import('./features/prejob/prejob.routing').then(x => x.preJobRoutes);
const projectsModule = () => import('./features/project/project.routing').then(x => x.projectRoutes);
const searchModule = () => import('./features/search/search.routing').then(x => x.searchRoutes);
const summaryPageModule = () => import('./features/summary-page/summary-page.routing').then(x => x.summaryRoutes);
const waterClassModule = () => import('./features/water-classification/water-classification.routing').then(x => x.waterClassificationRoutes);
const postJobsModule = () => import('./features/postjob/postjob.routing').then(x => x.postjobRoutes);

export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  // { path: 'auth', component: AuthCallbackComponent },
  { path: 'about', component: AboutComponent },   
  { path: '403', component: ForbiddenComponent },
  { path: 'dashboard', loadChildren: dashboardModule, canActivate: [RoleGuard, MsalGuard ], data: {roles: permissions.dashboard.read}},
  { path: 'audits', loadChildren: auditsModule, canActivate: [MsalGuard, RoleGuard], data: {roles: permissions.audit.read}},  
  { path: 'chemicals', loadChildren: chemicalsModule, canActivate: [MsalGuard, RoleGuard ], data: {roles: permissions.chemical.write}},
  { path: 'crews', loadChildren: crewsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.crew.write}},
  { path: 'waterclass', loadChildren: waterClassModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.water.write}},
  { path: 'customers', loadChildren: customersModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.customer.write }},
  { path: 'companys', loadChildren: companysModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.company.write }},
  { path: 'projects', loadChildren: projectsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.project.read}},
  { path: 'logwas', loadChildren: logWasModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.log.read}},
  { path: 'logbqs', loadChildren: logBqsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.log.read}},
  { path: 'logatps', loadChildren: logAtpsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.log.read}},
  { path: 'logacids', loadChildren: logAcidsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.log.read}},
  { path: 'prejob', loadChildren: preJobModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.log.read}},
  { path: 'search', loadChildren: searchModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.search.read}},
  { path: 'charts', loadChildren: chartsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.chart.read}},
  { path: 'summarypage', loadChildren: summaryPageModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.summary.read }},
  { path: 'comparationpage', loadChildren: comparationPageModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.compare.read }}, 
  { path: 'postjob', loadChildren: postJobsModule, canActivate: [MsalGuard, RoleGuard], data: { roles: permissions.postJob.read}},
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

export class AppRoutingModule { 
  getNavigationRoutes(){        
  return routes;
  }
}

@Injectable({ providedIn: 'root' })
export class NavigationProvider {
  getNavigationRoutes(): Routes {
    return routes; // or filtered/custom logic
  }
}
